import { styled } from '@mui/material';
import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Container, Text } from 'shell/components';
import DesktopSettings from './desktop';
import MobileSettings from './mobile';
import TabletSettings from './tablet';

const layouts = { desktop: DesktopSettings, tablet: TabletSettings, mobile: MobileSettings };

const SettingsPageLayout = () => {
    const { device } = useViewport();
    const { t } = useTranslation();
    const Layout = layouts[device] || DesktopSettings;
    return (
        <PageContainer>
            <ScreenReaderTitle component='h1'>{t('settings.title', 'Settings')}</ScreenReaderTitle>
            <Layout />
        </PageContainer>
    );
};

const PageContainer = styled(Container)(({ theme }) => ({
    background: theme.palette.ensightful.neutral[50],
    boxSizing: 'border-box',
    maxWidth: 1440,
    minHeight: '100%',
    padding: theme.spacing(5, 10),
    [theme.breakpoints.down('tablet')]: { padding: theme.spacing(2, 0) },
}));

const ScreenReaderTitle = styled(Text)(() => ({
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
}));

export default SettingsPageLayout;
